module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-non-bodymatter element-container-single element-type-none element-with-heading",
    attrs: {
      "id": "uncategorized"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "uncategorized-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Book Description")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "uncategorized-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("In "), _c('i', [_vm._v("Today I Remember")]), _vm._v(", Martin L. Shoemaker—award-winning author of "), _c('i', [_vm._v("Today I Am Carey")]), _vm._v(" and "), _c('i', [_vm._v("The Last Dance")]), _vm._v("—shares stories written as tributes to the people who inspired him in his life and his writing.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("A circus acrobat relives tragedy and triumph")]), _vm._v(" "), _c('li', [_vm._v("Leonardo da Vinci’s greatest creation exceeds even his vision")]), _vm._v(" "), _c('li', [_vm._v("A manager must save a space colony from starvation")]), _vm._v(" "), _c('li', [_vm._v("An Alzheimer’s patient and her android caretaker experience life through her delusions")]), _vm._v(" "), _c('li', [_vm._v("A girl must keep her father alive after an accident on the Moon")]), _vm._v(" "), _c('li', [_vm._v("A Lunar rescue squad races to find a lost transport ship")]), _vm._v(" "), _c('li', [_vm._v("A vampire’s assistant must help him to face the great detective")]), _vm._v(" "), _c('li', [_vm._v("A young man in Nigeria talks with the spirit of the wood")]), _vm._v(" "), _c('li', [_vm._v("A dying patient volunteers for an experiment with unforeseen side-effects")]), _vm._v(" "), _c('li', [_vm._v("A teacher must teach her students to survive the wreck of their spaceship")]), _vm._v(" "), _c('li', [_vm._v("A young law student returns to Haiti to rescue his dead grandfather from the bokor")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Each story begins with an explanation of how it came to be and who inspired it. These are some of Martin’s best stories—and best memories.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0feff2f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bookdescription.vue
// module id = 60
// module chunks = 0